import BaseComponentController from "./base_component_controller"

export default class extends BaseComponentController {
  static targets = ['activeFiltersSeparator']
  static values = { hideClass: String }

  connect() {
    this.element.addEventListener('design-system--term-searcher:search', (e) => {
      this.activeFiltersSeparatorTarget.classList.toggle(this.hideClassValue, !e.detail.hasResults)
    })
  }
}
